// Code generated by protoc-gen-ts. DO NOT EDIT.
// protoc-gen-ts is an Art Processors production, found in mos-sdk-py.

import { Metadata } from "generated/mos/entity";
import { Codec, DecodeContext, RemoteObject, WebRPCError, decodeMessageRepeated, ensureScalar } from "generated/webrpc";

// ValidationFailure is a record created when an issue fails validation
// 
// only invalid entities will have a corresponding ValidationFailure
export namespace ValidationFailure {
  export const refName = "mos.org.getty.validation.ValidationFailure" as const;
  export type Entity = {
    readonly type: typeof refName,
    // ValidationFailures share an identifier with the entity they correspond to
    readonly ref: { readonly typename: string, readonly id: string } | undefined,
    // They are persistent so they have created/modified dates
    readonly metadata: Metadata.Entity | undefined,
    // The list of issues for the entity
    readonly issues: ReadonlyArray<ValidationFailure.Issue.Entity>,
    // The display name for the entity this validation is for (in preferred language)
    readonly entityName: string,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
    metadata: undefined,
    issues: [],
    entityName: "",
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["ref"] = v.ref;
      obj["metadata"] = Metadata.codec.encode(v.metadata);
      obj["issues"] = [];
      for (const item of v.issues) {
        obj["issues"].push(ValidationFailure.Issue.codec.encode(item));
      }
      obj["entityName"] = v.entityName;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.validation.ValidationFailure");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      out["metadata"] = ctx.decode(Metadata.codec, v["metadata"], "metadata");
      out["issues"] = decodeMessageRepeated(ctx, ValidationFailure.Issue.codec, v["issues"], "issues");
      out["entityName"] = ensureScalar(ctx, v["entityName"], "string");
      return out as any as Entity;
    }
  }();
  export namespace Issue {
    export const refName = "mos.org.getty.validation.ValidationFailure.Issue" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly issueType: ValidationFailure.Issue.IssueType,
      readonly attributeName: string,
      readonly attributeDisplayName: string,
    }
    export const defaults: Entity = {
      type: refName,
      issueType: "NO_ISSUE",
      attributeName: "",
      attributeDisplayName: "",
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.validation.ValidationFailure.Issue");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        {
          const ev = ensureScalar(ctx, v["issueType"], "string") || defaults["issueType"];
          if (!ValidationFailure.Issue.IssueTypeValues.has(ev as any)) {
            throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.validation.ValidationFailure.Issue.IssueType`);
          }
          out["issueType"] = ev as any;
        }
        out["attributeName"] = ensureScalar(ctx, v["attributeName"], "string");
        out["attributeDisplayName"] = ensureScalar(ctx, v["attributeDisplayName"], "string");
        return out as any as Entity;
      }
    }();
    export const IssueTypeValues = new Set([
      'NO_ISSUE' as const,
      'MISSING_REQUIRED_ATTRIBUTE' as const,
      'TOUR_CONTAINS_NO_STOPS' as const,
      'TOUR_CONTAINS_STOPS_FROM_MULTIPLE_SITES' as const,
      'TOUR_CATEGORY_CONTAINS_TOURS_FROM_MULTIPLE_SITES' as const,
      'TOUR_CONTAINS_STOPS_AND_HAS_WEBPAGE_URL' as const,
      'INVALID_COLOR' as const,
      'MISSING_TMS_OBJECT' as const,
    ]);
    export type IssueType = typeof IssueTypeValues extends Set<infer U> ? U : never;

  }

}

